import React, { useState } from 'react';
import {
  MdClose, MdSmartphone, MdLanguage, MdShare, MdBookmarkBorder,
  MdThumbUp, MdThumbDown, MdComment, MdViewColumn, MdLocationOn,
  MdAutoAwesome, MdPlayCircleOutline, MdMap, MdArticle, MdWhatsapp
} from 'react-icons/md';
import { displayState, ALL_INDIA_STATE } from '../utils/format';

const WebPreviewModal = ({ article, onClose }) => {
  const [viewMode, setViewMode] = useState('split'); // 'split', 'web', 'app'
  const [activeTab, setActiveTab] = useState('news'); // Flutter App active tab ('news', 'zones', 'status', 'timer')

  if (!article) return null;

  const authorName = article.contributor?.name || article.author_name || article.creator?.name || article.reporter_name || 'Super Admin';
  const categoryName = article.category ? article.category.replace('_', ' ') : 'వార్తలు';
  const cityName = article.city ? displayState(article.city.replace('_', ' ')) : ALL_INDIA_STATE;
  const dateStr = article.published_at ? new Date(article.published_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  const timeStr = article.published_at ? new Date(article.published_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : '04:50 PM';
  const mediaUrl = article.image_url || article.thumbnail_url;
  const videoUrl = article.video_url;

  return (
    <div className="web-preview-overlay" onClick={onClose} style={{ backdropFilter: 'blur(10px)', background: 'rgba(15, 23, 42, 0.85)' }}>
      <div
        className="web-preview-modal-dual"
        onClick={e => e.stopPropagation()}
        style={{
          background: '#F8FAFC',
          width: '96%',
          maxWidth: viewMode === 'split' ? '1420px' : (viewMode === 'app' ? '540px' : '960px'),
          borderRadius: 24,
          maxHeight: '93vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          margin: 'auto'
        }}
      >
        {/* Top Control Header Bar */}
        <div style={{
          padding: '14px 24px',
          background: '#0F172A',
          color: '#FFFFFF',
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #1E293B',
          flexWrap: 'wrap',
          gap: 12
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 18, fontWeight: 900, color: '#DC2626', letterSpacing: -0.5 }}>UDAYAM</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: '#F8FAFC' }}>Dual Article Verification Engine</span>
            <span className="badge" style={{ background: 'rgba(220, 38, 38, 0.25)', color: '#FCA5A5', fontSize: 11, padding: '4px 10px', border: '1px solid rgba(220, 38, 38, 0.3)' }}>
              Live App Replica
            </span>
          </div>

          {/* View Mode Switcher Controls */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#1E293B', padding: 4, borderRadius: 10 }}>
            <button
              className="btn btn-sm"
              onClick={() => setViewMode('split')}
              style={{
                background: viewMode === 'split' ? '#DC2626' : 'transparent',
                color: viewMode === 'split' ? '#FFF' : '#94A3B8',
                border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6
              }}
            >
              <MdViewColumn size={15} /> Split View
            </button>
            <button
              className="btn btn-sm"
              onClick={() => setViewMode('web')}
              style={{
                background: viewMode === 'web' ? '#DC2626' : 'transparent',
                color: viewMode === 'web' ? '#FFF' : '#94A3B8',
                border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6
              }}
            >
              <MdLanguage size={15} /> 🌐 Web Preview
            </button>
            <button
              className="btn btn-sm"
              onClick={() => setViewMode('app')}
              style={{
                background: viewMode === 'app' ? '#DC2626' : 'transparent',
                color: viewMode === 'app' ? '#FFF' : '#94A3B8',
                border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6
              }}
            >
              <MdSmartphone size={15} /> 📱 Flutter App Preview
            </button>
          </div>

          <button
            onClick={onClose}
            style={{ background: '#334155', color: '#FFF', border: 'none', width: 36, height: 36, borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <MdClose size={20} />
          </button>
        </div>

        {/* Dual Preview Body Container */}
        <div
          style={{
            padding: 20,
            overflowY: 'auto',
            display: 'grid',
            gridTemplateColumns: viewMode === 'split' ? 'repeat(auto-fit, minmax(400px, 1fr))' : '1fr',
            gap: 24,
            alignItems: 'start'
          }}
        >
          {/* ==================== LEFT PANEL: WEB PREVIEW ==================== */}
          {(viewMode === 'split' || viewMode === 'web') && (
            <div style={{ background: '#FFFFFF', borderRadius: 16, border: '1px solid #E2E8F0', boxShadow: '0 4px 15px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
              {/* Web Header Bar */}
              <div style={{ background: '#111827', color: '#FFF', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '3px solid #DC2626' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ color: '#DC2626', fontWeight: 900, fontSize: 16, letterSpacing: -0.5 }}>ఉదయం</span>
                  <span style={{ fontSize: 12, color: '#9CA3AF' }}>udayam.org | Website Preview</span>
                </div>
                <div style={{ fontSize: 11, background: '#374151', padding: '2px 8px', borderRadius: 4, color: '#E5E7EB' }}>
                  Desktop View
                </div>
              </div>

              {/* Web Content Body */}
              <div style={{ padding: '28px 32px' }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 14 }}>
                  <span style={{ background: '#FEE2E2', color: '#DC2626', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 99, textTransform: 'uppercase' }}>
                    {categoryName}
                  </span>
                  {cityName && (
                    <span style={{ fontSize: 12, color: '#64748B', display: 'flex', alignItems: 'center', gap: 4 }}>
                      <MdLocationOn size={14} /> {cityName}
                    </span>
                  )}
                </div>

                <h1 style={{ fontSize: 26, fontWeight: 800, color: '#0F172A', lineHeight: 1.35, marginBottom: 16, fontFamily: 'Ramabhadra, serif' }}>
                  {article.title || 'Untitled Article'}
                </h1>

                <div style={{ display: 'flex', gap: 14, color: '#64748B', fontSize: 13, borderBottom: '1px solid #F1F5F9', paddingBottom: 14, marginBottom: 20 }}>
                  <span>By <strong style={{ color: '#0F172A' }}>{authorName}</strong></span>
                  <span>•</span>
                  <span>{dateStr}</span>
                  <span>•</span>
                  <span>Region: {cityName}</span>
                </div>

                {/* Media Component */}
                {article.media_type === 'video' && videoUrl ? (
                  <video
                    src={videoUrl}
                    poster={mediaUrl}
                    controls
                    style={{ width: '100%', borderRadius: 12, marginBottom: 24, aspectRatio: '16/9', background: '#000' }}
                  />
                ) : (
                  mediaUrl && (
                    <img
                      src={mediaUrl}
                      alt=""
                      style={{ width: '100%', borderRadius: 12, marginBottom: 24, aspectRatio: '720 / 590', objectFit: 'cover', background: '#F8FAFC' }}
                    />
                  )
                )}

                {/* Summary / Content */}
                {article.summary && (
                  <div style={{ fontSize: 16, lineHeight: 1.7, color: '#1E293B', fontWeight: 600, background: '#F8FAFC', borderLeft: '4px solid #DC2626', padding: '16px 20px', borderRadius: '0 12px 12px 0', marginBottom: 20 }}>
                    {article.summary}
                  </div>
                )}

                {article.content && (
                  <div style={{ fontSize: 15, lineHeight: 1.8, color: '#334155', whiteSpace: 'pre-line' }}>
                    {article.content}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ==================== RIGHT PANEL: EXACT FLUTTER APP REPLICA ==================== */}
          {(viewMode === 'split' || viewMode === 'app') && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#64748B', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
                <MdSmartphone size={16} color="#DC2626" /> Exact Production Flutter App UI
              </div>

              {/* Realistic Mobile Phone Bezel (Flexible Height to fit full article without scrolling) */}
              <div
                style={{
                  width: '360px',
                  minHeight: '680px',
                  height: 'auto',
                  background: '#0F172A',
                  borderRadius: '44px',
                  padding: '12px',
                  boxShadow: '0 25px 50px -12px rgba(15, 23, 42, 0.4), 0 0 0 2px #334155',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* Top Camera Island Notch */}
                <div style={{ position: 'absolute', top: 18, left: '50%', transform: 'translateX(-50%)', width: 90, height: 18, background: '#000000', borderRadius: 10, zIndex: 30 }} />

                {/* Inner Screen Container */}
                <div
                  style={{
                    background: '#FFFFFF',
                    borderRadius: '34px',
                    minHeight: '656px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  {/* 1. TOP MOBILE STATUS BAR OVER MEDIA */}
                  <div style={{ height: 32, background: 'rgba(0,0,0,0.2)', color: '#FFFFFF', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 20px', fontSize: 11, fontWeight: 700, zIndex: 25, flexShrink: 0, position: 'absolute', top: 0, left: 0, right: 0 }}>
                    <span>5:30</span>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 10 }}>
                      <span>VoLTE</span> <span>4G</span> <span>📶</span> <span>🔋 62%</span>
                    </div>
                  </div>

                  {/* 2. FULL CONTENT BODY (DYNAMICALLY EXPANDED, NO SCROLLBAR) */}
                  <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    {/* Top Edge-to-Edge Media with Overlays */}
                    <div style={{ position: 'relative', width: '100%', aspectRatio: '720 / 590', background: '#000', flexShrink: 0 }}>
                      {article.media_type === 'video' && videoUrl ? (
                        <video
                          src={videoUrl}
                          poster={mediaUrl}
                          controls
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        mediaUrl && (
                          <img
                            src={mediaUrl}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        )
                      )}

                      {/* Dark Gradient Overlay at Bottom of Image */}
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 70, background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', zIndex: 5 }} />

                      {/* Bottom-Left Image Overlay: Location Pin or Category */}
                      <div style={{ position: 'absolute', bottom: 12, left: 12, display: 'flex', alignItems: 'center', gap: 4, color: '#FFFFFF', fontSize: 12.5, fontWeight: 700, textShadow: '0 1px 3px rgba(0,0,0,0.8)', zIndex: 10 }}>
                        <MdLocationOn size={16} color="#FFFFFF" />
                        <span>{article.category && article.category.trim() !== 'General' ? article.category : cityName}</span>
                      </div>

                      {/* Bottom-Right Image Overlay: Telugu Brand Logo (ఉదయం) */}
                      <div style={{ position: 'absolute', bottom: 10, right: 14, display: 'flex', alignItems: 'center', gap: 4, color: '#FFFFFF', zIndex: 10 }}>
                        <span style={{ fontSize: 20, fontWeight: 900, fontFamily: 'Ramabhadra, serif', letterSpacing: -0.5, textShadow: '0 2px 4px rgba(0,0,0,0.9)' }}>ఉదయం</span>
                        <span style={{ fontSize: 10, color: '#FDBA74' }}>☀️</span>
                      </div>
                    </div>

                    {/* Floating Green WhatsApp Share Button */}
                    <div style={{ position: 'relative', height: 0, zIndex: 15 }}>
                      <div
                        style={{
                          position: 'absolute',
                          top: -10,
                          right: 12,
                          width: 38,
                          height: 38,
                          borderRadius: '50%',
                          background: '#25D366',
                          color: '#FFFFFF',
                          display: 'flex',
                          alignItems: 'center',
                          justify: 'center',
                          boxShadow: '0 4px 10px rgba(37, 211, 102, 0.4)',
                          cursor: 'pointer'
                        }}
                        title="Share on WhatsApp"
                      >
                        <MdWhatsapp style={{ marginLeft: "8px" }}  size={22} />
                      </div>
                    </div>

                    {/* Article Content Section (Full Unclamped Description) */}
                    <div style={{ padding: '20px 16px 14px 16px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <div>
                        {/* Bold Telugu Headline */}
                        <h2 style={{
                          fontSize: 17.5,
                          fontWeight: 800,
                          color: '#0F172A',
                          lineHeight: 1.4,
                          marginBottom: 14,
                          fontFamily: 'Ramabhadra, serif'
                        }}>
                          {article.title || 'Untitled Article'}
                        </h2>

                        {/* Summary / Lead Paragraph */}
                        {article.summary && (
                          <p style={{ fontSize: 13.5, lineHeight: 1.65, color: '#334155', fontWeight: 500, marginBottom: 12, whiteSpace: 'pre-line' }}>
                            {article.summary}
                          </p>
                        )}

                        {/* Full Description Content Paragraphs */}
                        {article.content && (
                          <div style={{ fontSize: 13.5, lineHeight: 1.7, color: '#475569', whiteSpace: 'pre-line', marginBottom: 14 }}>
                            {article.content}
                          </div>
                        )}
                      </div>

                      {/* Muted Right-Aligned Timestamp */}
                      <div style={{ textAlign: 'right', fontSize: 11.5, color: '#94A3B8', fontWeight: 600, marginTop: 10, marginBottom: 4 }}>
                        {dateStr} • {timeStr}
                      </div>
                    </div>
                  </div>

                  {/* 3. FLUTTER APP ACTION BAR */}
                  <div style={{ borderTop: '1px solid #F1F5F9', padding: '8px 16px', background: '#FFFFFF', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13, fontWeight: 600, color: '#64748B', flexShrink: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <MdThumbUp size={18} color="#94A3B8" />
                      <span>{article.like_count || 55}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <MdThumbDown size={18} color="#94A3B8" />
                      <span>{article.dislike_count || 6}</span>
                    </div>

                    {/* Central Circular Red Share Button */}
                    <div
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 12,
                        background: '#EF4444',
                        color: '#FFFFFF',
                        display: 'flex',
                        alignItems: 'center',
                        justify: 'center',
                        boxShadow: '0 4px 8px rgba(239, 68, 68, 0.3)',
                        cursor: 'pointer'
                      }}
                      title="Share Article"
                    >
                      <MdShare style={{ marginLeft: "8px" }} size={20} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <MdComment size={18} color="#94A3B8" />
                      <span>{article.comment_count || 0}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <MdBookmarkBorder size={20} color="#94A3B8" />
                    </div>
                  </div>

                  {/* 4. FLUTTER APP BOTTOM NAVIGATION FOOTER */}
                  <div style={{ background: '#FFFFFF', borderTop: '1px solid #F1F5F9', padding: '6px 12px 8px 12px', display: 'flex', justifyContent: 'space-around', alignItems: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>
                    <div onClick={() => setActiveTab('news')} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: activeTab === 'news' ? '#DC2626' : '#94A3B8', gap: 2, cursor: 'pointer' }}>
                      <MdArticle size={22} />
                      <span style={{ fontSize: 11 }}>వార్తలు</span>
                    </div>
                    <div onClick={() => setActiveTab('zones')} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: activeTab === 'zones' ? '#DC2626' : '#94A3B8', gap: 2, cursor: 'pointer' }}>
                      <MdMap size={22} />
                      <span style={{ fontSize: 11 }}>జోన్స్</span>
                    </div>
                    <div onClick={() => setActiveTab('status')} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: activeTab === 'status' ? '#DC2626' : '#94A3B8', gap: 2, cursor: 'pointer' }}>
                      <MdAutoAwesome size={22} />
                      <span style={{ fontSize: 11 }}>స్టేటస్</span>
                    </div>
                    <div onClick={() => setActiveTab('timer')} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: activeTab === 'timer' ? '#DC2626' : '#94A3B8', gap: 2, cursor: 'pointer' }}>
                      <MdPlayCircleOutline size={22} />
                      <span style={{ fontSize: 11 }}>టైమర్</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WebPreviewModal;
